import { Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import IconButton from "./IconButton";
import PropTypes from "prop-types";
import React from "react";

/* Largeur et alignement de la colonne « Actions », identiques partout. */
export const ACTIONS_COLUMN = {
  title: "Actions",
  key: "actions",
  width: 100,
  align: "center",
};

/**
 * Actions de ligne : icones seules + infobulle.
 * onEdit optionnel (onglets sans modification : seul Supprimer s'affiche).
 */
function RowActions({ onEdit, onDelete }) {
  return (
    <span className="cti-row-actions">
      {onEdit && (
        <IconButton
          title="Modifier"
          label="Modifier la ligne"
          icon={<EditOutlined />}
          onClick={onEdit}
        />
      )}
      <Popconfirm
        title="Supprimer cet élément ?"
        okText="Supprimer"
        cancelText="Annuler"
        okButtonProps={{ danger: true }}
        onConfirm={onDelete}
      >
        <IconButton
          title="Supprimer"
          label="Supprimer la ligne"
          danger
          icon={<DeleteOutlined />}
        />
      </Popconfirm>
    </span>
  );
}

RowActions.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
};

export default RowActions;
